import _ from "lodash";
import React from "react";

// UI
import classes from "../CardComments.scss";
import CommentItemV2 from "../../CommentItemV2/CommentItemV2";
import { Button, useDSContext } from "@toddle-edu/ds-web";
import { CommentMultipleOutlined } from "@toddle-edu/ds-icons";

import { isPortfolioParityEnabledAndIsJournalRoute } from "Post/utils";

const styles = {
  viewCommentButtonAtTopStyle: { margin: "8px 0" },
  buttonStyle: { margin: "8px 0" },
  viewCommentButtonAtTopStyleV2: { margin: "16px 0 0px 0" },
};

const CommentFeed = props => {
  const {
    isSidePaneContent,
    comments,
    showCommentBox,
    t,
    showViewAllCommentsButton,
    setShowViewAllCommentsButton,
    totalCount,
    userId,
    canComment,
    isStaff,
    onEditComment,
    onDeleteComment,
    showCommentBadge,
    showViewCommentButtonAtTop = false,
    showViewCommentButtonText = "journal:view_more_count_comment",
    canDelete,
    updateCommentReadCount,
    defaultStudentNameOrderPreference,
    isProjectPostCard,
  } = props;
  const { dsVersion } = useDSContext();
  const isDSV2 = dsVersion === "2.0";

  const commentStyles = (isSidePaneContent, showCommentBox, comments) => ({
    commentIcon: {
      display: "flex",
    },
    commentListStyles: {
      paddingBottom:
        !isSidePaneContent && (showCommentBox || comments?.length)
          ? "16px"
          : "0px",
    },
  });

  const commentIcon = () => (
    <div
      style={
        commentStyles(isSidePaneContent, showCommentBox, comments).commentIcon
      }
    >
      <span className={classes.commentIcon}>
        <CommentMultipleOutlined variant="warning" />
      </span>
      <span className={classes.commentText}>{t("common:comment_plural")}</span>
    </div>
  );

  const viewMoreCommentButton = ({ buttonContainerStyle = {} } = {}) =>
    showViewAllCommentsButton && totalCount - _.size(comments) > 0 ? (
      <div style={buttonContainerStyle}>
        <Button
          _legacy_variant={"inline"}
          size="large"
          type="inline"
          variant="neutral"
          className={isDSV2 ? classes.button : null}
          onClick={() => {
            setShowViewAllCommentsButton(false);
            //_.isFunction(fetchMoreFeed) && fetchMoreFeed();
          }}
          style={isDSV2 ? {} : styles.buttonStyle}
        >
          <span className="text-label-3">
            {_.capitalize(
              t(showViewCommentButtonText, {
                count: totalCount - _.size(comments),
              })
            )}
          </span>
        </Button>
      </div>
    ) : null;

  return (
    <>
      {showViewCommentButtonAtTop && showViewAllCommentsButton
        ? viewMoreCommentButton({
            buttonContainerStyle: isDSV2
              ? styles.viewCommentButtonAtTopStyleV2
              : styles.viewCommentButtonAtTopStyle,
          })
        : null}
      {isSidePaneContent && comments?.length > 0 ? commentIcon() : null}

      {!_.isEmpty(comments) ? (
        <div
          className={classes.commentsReverseOrderContainer}
          style={{
            paddingTop: isPortfolioParityEnabledAndIsJournalRoute()
              ? "8px"
              : "4px",
          }}
        >
          {_.map(comments, comment => {
            return (
              <CommentItemV2
                key={_.get(comment, "node.id")}
                comment={_.get(comment, "node", undefined)}
                canEdit={
                  _.get(comment, "node.createdBy.id") == userId && canComment
                }
                canDelete={
                  (_.get(comment, "node.createdBy.id") == userId ||
                    (isStaff &&
                      _.get(comment, "node.createdBy.type") != "staff")) &&
                  canDelete
                }
                onEditComment={onEditComment}
                onDeleteComment={onDeleteComment}
                showCommentBadge={showCommentBadge}
                updateCommentReadCount={updateCommentReadCount}
                defaultStudentNameOrderPreference={
                  defaultStudentNameOrderPreference
                }
                excludePronounFromAvatar={true}
                isProjectPostCard={isProjectPostCard}
              />
            );
          })}
        </div>
      ) : null}

      {!showViewCommentButtonAtTop ? viewMoreCommentButton() : null}
    </>
  );
};

export default CommentFeed;
